(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('collection-faq-question-btn')) return;

    const item = e.target.closest('.collection-faq-list-item');
    const section = e.target.closest('.cf-jb-collection-faq-section');
    const isActive = item.classList.contains('is-active');

    section.querySelectorAll('.collection-faq-list-item').forEach((el) => el.classList.remove('is-active'));

    if (!isActive) item.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Splide !== 'undefined') {
    var new_arrival_splide = new Splide('.reviews-slider', {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      arrows: false,
      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        768: { perPage: 1 }
      }
    });

    new_arrival_splide.mount();

    var prevArrow = document.querySelector('.custom-prev-reviews');
    var nextArrow = document.querySelector('.custom-next-reviews');

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener('click', function () {
        new_arrival_splide.go('<');
      });

      nextArrow.addEventListener('click', function () {
        new_arrival_splide.go('>');
      });

      function updateArrows() {
        if (new_arrival_splide.options.type === 'loop') {
          prevArrow.classList.remove('is-disabled');
          nextArrow.classList.remove('is-disabled');
          return;
        }

        var index = new_arrival_splide.index;
        var end = new_arrival_splide.Components.Controller.getEnd();

        if (index === 0) {
          prevArrow.classList.add('is-disabled');
        } else {
          prevArrow.classList.remove('is-disabled');
        }

        if (index === end) {
          nextArrow.classList.add('is-disabled');
        } else {
          nextArrow.classList.remove('is-disabled');
        }
      }

      new_arrival_splide.on('mounted move', updateArrows);
    } else {
      console.warn('Custom arrow elements not found in DOM.');
    }
  } else {
    console.error('Splide.js not loaded. Please include Splide library.');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
    (function () {
    var heroSplideStarted = false;
    function initHeroSplide() {
      if (heroSplideStarted) return;
      heroSplideStarted = true;
      new Splide('.hero-slider', {
        type       : 'fade',
        autoplay   : true,
        interval   : 3000,
        speed      : 800,
        rewind     : true,
        arrows     : true,
        pagination : true,
        pauseOnHover: false,
        pauseOnFocus: false,
      }).mount();
    }
    function scheduleHeroSplide() {
      // The timeout stops a busy main thread from delaying the slider for many seconds.
      if (window.requestIdleCallback) window.requestIdleCallback(initHeroSplide, { timeout: 1500 });
      else window.setTimeout(initHeroSplide, 0);
    }
    if (document.readyState === 'complete') {
      scheduleHeroSplide();
    } else {
      window.addEventListener('load', scheduleHeroSplide);
    }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-articles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Make sure Splide is loaded
  if (typeof Splide !== 'undefined') {
    
    // Initialize Splide
    var latest_article_splide = new Splide('.articles-splide', {
      type: 'slide',        // change to 'loop' if you want infinite sliding
      perPage: 3,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      arrows: false,        // disable default Splide arrows
      autoplay: false,      // ensure autoplay is off
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        992: { perPage: 2 },
        768: { perPage: 1 }
      }
    });

    // Mount Splide
    latest_article_splide.mount();

    // Get custom arrow buttons
    var prevArrow = document.querySelector('.custom-prev-latest-article');
    var nextArrow = document.querySelector('.custom-next-latest-article');

    if (prevArrow && nextArrow) {
      // On click - move slides
      prevArrow.addEventListener('click', function() {
        latest_article_splide.go('<');
      });

      nextArrow.addEventListener('click', function() {
        latest_article_splide.go('>');
      });

      // Function to update arrow states (disabled/enabled)
      function updateArrows() {
        if (latest_article_splide.options.type === 'loop') {
          prevArrow.classList.remove('is-disabled');
          nextArrow.classList.remove('is-disabled');
          return;
        }

        var index = latest_article_splide.index;
        var end = latest_article_splide.Components.Controller.getEnd();

        if (index === 0) {
          prevArrow.classList.add('is-disabled');
        } else {
          prevArrow.classList.remove('is-disabled');
        }

        if (index === end) {
          nextArrow.classList.add('is-disabled');
        } else {
          nextArrow.classList.remove('is-disabled');
        }
      }

      // Run once on mount and again when moving
      latest_article_splide.on('mounted move', updateArrows);

    } else {
      console.warn('Custom arrow elements not found in DOM.');
    }

  } else {
    console.error('Splide.js not loaded. Please include Splide library.');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.story-section-slider').forEach(function(slider) {
      new Splide(slider, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 4000,
        speed: 800,
        pauseOnHover: true,
        classes: {
          arrows: 'splide__arrows custom-arrows',
          arrow : 'splide__arrow custom-arrow',
          prev  : 'splide__arrow--prev custom-prev',
          next  : 'splide__arrow--next custom-next',
        },
      }).mount();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrival"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Make sure Splide is loaded
  if (typeof Splide !== 'undefined') {
    
    // Initialize Splide
    var new_arrival_splide = new Splide('.new-arrival-main', {
      type: 'slide',        // change to 'loop' if you want infinite sliding
      perPage: 4,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      arrows: false,        // disable default Splide arrows
      autoplay: false,      // ensure autoplay is off
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: false,
      breakpoints: {
        992: { perPage: 3 },
        768: { perPage: 2 }
      }
    });
    
    // Mount Splide
    new_arrival_splide.mount();

    // Get custom arrow buttons
    var prevArrow = document.querySelector('.custom-prev-newarrival');
    var nextArrow = document.querySelector('.custom-next-newarrival');

    if (prevArrow && nextArrow) {
      // On click - move slides
      prevArrow.addEventListener('click', function() {
        new_arrival_splide.go('<');
      });

      nextArrow.addEventListener('click', function() {
        new_arrival_splide.go('>');
      });

      // Function to update arrow states (disabled/enabled)
      function updateArrows() {
        if (new_arrival_splide.options.type === 'loop') {
          prevArrow.classList.remove('is-disabled');
          nextArrow.classList.remove('is-disabled');
          return;
        }

        var index = new_arrival_splide.index;
        var end = new_arrival_splide.Components.Controller.getEnd();

        if (index === 0) {
          prevArrow.classList.add('is-disabled');
        } else {
          prevArrow.classList.remove('is-disabled');
        }

        if (index === end) {
          nextArrow.classList.add('is-disabled');
        } else {
          nextArrow.classList.remove('is-disabled');
        }
      }

      // Run once on mount and again when moving
      new_arrival_splide.on('mounted move', updateArrows);

    } else {
      console.warn('Custom arrow elements not found in DOM.');
    }

  } else {
    console.error('Splide.js not loaded. Please include Splide library.');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category-mobile"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('.category-slider-mobile', {
      type: 'slide',
      // perPage: 10,
      perMove: 5,
      arrows: false,
      pagination: false,
      autoplay: false,
      rewind: false,
      fixedWidth: '60px',
      gap: '12px',
      drag: true, 
      padding:{
        left: '16px',
        right: '16px',
      },
      breakpoints: {
        576: {
          // perPage: 4,
        },
      },
    }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
// Check every 100ms until slider exists
const initSlider = setInterval(() => {
  const sliderEl = document.querySelector('.category-slider');

  if (sliderEl && typeof Splide !== 'undefined') {

    clearInterval(initSlider); // Stop checking

    var splide = new Splide('.category-slider', {
      type: 'loop',
      perPage: 7,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      arrows: false,
      autoplay: false,     // using custom autoplay
      speed: 800,
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        1500: { perPage: 6 },
        1200: { perPage: 5 },
        992:  { perPage: 4 },
        768:  { perPage: 3 },
        480:  { perPage: 2 },
      },
    });

    splide.mount();

    // 👉 Custom Autoplay using setInterval
    let autoSlide = setInterval(() => {
      splide.go('>');
    }, 3000);

    const stopAuto = () => clearInterval(autoSlide);

    const prev = document.querySelector('.custom-prev');
    const next = document.querySelector('.custom-next');

    if (prev && next) {
      prev.addEventListener('click', () => {
        splide.go('<');
        stopAuto();
      });

      next.addEventListener('click', () => {
        splide.go('>');
        stopAuto();
      });
    }

    // Optional refresh
    setTimeout(() => splide.refresh(), 300);
  }
}, 100);



  } catch(e) { console.error(e); }
})();
})();
